import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WidgetState {
    selectedSingleSavedWidget: any | null;
    localWidgetStore: any | null;
}

const initialState: WidgetState = {
    selectedSingleSavedWidget: null,
    localWidgetStore: null,
};

const widgetTempSlice = createSlice({
    name: 'widgets',
    initialState,
    reducers: {
        createWidgetStoreLocally: (state, action: PayloadAction<any>) => {
            state.localWidgetStore = action.payload;
        },
        setSelectedSingleSavedWidget: (state, action: PayloadAction<any>) => {
            state.selectedSingleSavedWidget = action.payload;
        }
    },
});

export const { createWidgetStoreLocally, setSelectedSingleSavedWidget } = widgetTempSlice.actions;

export default widgetTempSlice.reducer;
